(() => {
  const host = document.querySelector('dod-welcome-gift');
  if (!host || host.dataset.initialized) return;
  host.dataset.initialized = 'true';
  const dialog = host.querySelector('dialog');
  const copy = JSON.parse(host.querySelector('[data-gift-copy]').textContent);
  const requestedPreview = new URLSearchParams(location.search).get('gift_preview') === '1';
  const designMode = host.dataset.designMode === 'true';
  const ready = host.dataset.checkoutReady === 'true' && !designMode;
  const preview = designMode || (requestedPreview && host.dataset.themeRole !== 'main');
  if (!preview && !ready) return;
  const buttons = [...host.querySelectorAll('[data-gift-pick]')];
  const status = host.querySelector('[data-gift-status]');
  const seenKey = 'dod-ln-gift-seen';
  let previousFocus;
  let busy = false;
  let cartChanged = false;
  let seen = false;
  try { seen = sessionStorage.getItem(seenKey) === '1'; } catch (_) {}
  const markSeen = () => { try { sessionStorage.setItem(seenKey,'1'); } catch (_) {} };
  const close = () => {
    if (busy) return;
    markSeen();
    dialog.close();
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
    if (cartChanged && /\/cart\/?$/.test(location.pathname)) location.reload();
  };
  const showSelection = selected => buttons.forEach(choice=>{
    const checked = choice.dataset.giftPick === selected;
    choice.setAttribute('aria-pressed',String(checked));
    choice.textContent = checked ? copy.selected : copy.add;
    choice.closest('[data-gift-card]').classList.toggle('is-selected',checked);
  });
  document.addEventListener('dod:gift-state',event=>{
    showSelection(event.detail.selected);
    if (event.detail.message) status.textContent = event.detail.message;
    else if (event.detail.reserved) status.textContent = copy.reserved;
    else if (event.detail.selected) status.textContent = copy.added;
  });
  host.querySelectorAll('[data-gift-close]').forEach(button=>button.addEventListener('click',close));
  dialog.addEventListener('click',event=>{
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('cancel',event=>{ if (busy) event.preventDefault(); else markSeen(); });
  dialog.addEventListener('close',()=>{ if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true}); });
  buttons.forEach(button=>button.addEventListener('click',async ()=>{
    if (busy) return;
    if (!ready) {
      showSelection(button.dataset.giftPick);
      status.textContent = copy.preview_selected.replace('[game]',button.dataset.giftTitle);
      return;
    }
    if (!window.DODGameTiers) { status.textContent = copy.unavailable; return; }
    busy = true;
    host.setAttribute('aria-busy','true');
    const available = buttons.filter(choice=>!choice.disabled);
    available.forEach(choice=>{ choice.disabled = true; });
    status.textContent = copy.updating;
    try {
      const cart = await window.DODGameTiers.selectGift(button.dataset.giftPick);
      window.DODGameTiers.render(cart);
      cartChanged = true;
      markSeen();
    } catch (error) { status.textContent = error.message || copy.unavailable; }
    finally {
      busy = false;
      host.removeAttribute('aria-busy');
      available.forEach(choice=>{ choice.disabled = false; });
    }
  }));
  host.querySelector('[data-gift-preview]').hidden = ready || !preview;
  if (preview || !seen) {
    window.setTimeout(() => {
      if (!host.isConnected || dialog.open) return;
      previousFocus = document.activeElement;
      dialog.showModal();
    }, 2000);
  }
})();
